import { useEffect, useState } from "react";

// Tiny URL-query-string state hook. Reads the param on first render, then
// syncs subsequent state changes back to `window.location` (replaceState,
// no history entries — back-button would otherwise become annoying).
// Empty string is treated as absent: setting it removes the param.
export function useUrlState(key: string, initial = ""): [string, (v: string) => void] {
  const [value, setValue] = useState<string>(() => {
    if (typeof window === "undefined") return initial;
    const params = new URLSearchParams(window.location.search);
    return params.get(key) ?? initial;
  });

  useEffect(() => {
    if (typeof window === "undefined") return;
    const params = new URLSearchParams(window.location.search);
    if (value === "" || value === initial) params.delete(key);
    else params.set(key, value);
    const qs = params.toString();
    const newUrl = qs ? `${window.location.pathname}?${qs}` : window.location.pathname;
    window.history.replaceState(null, "", newUrl);
  }, [key, value, initial]);

  return [value, setValue];
}
